export const setTextAlignment = (alignment: string): string => {
  const glyphs = {
    left: 'u-textLeft',
    LeftAligned: 'u-textLeft',
    center: 'u-textCenter',
    Centered: 'u-textCenter',
    right: 'u-textRight',
    RightAligned: 'u-textRight',
    verticalCenter: 'u-flexAlignContentCenter',
  }
  if (glyphs[alignment as keyof typeof glyphs]) {
    return glyphs[alignment as keyof typeof glyphs]
  }
  return 'u-textLeft'
}
